"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShiftEndedOrigin = exports.ShiftRule = exports.ShiftNoteType = void 0;
var ShiftNoteType;
(function (ShiftNoteType) {
    ShiftNoteType["ShiftForm"] = "ShiftForm";
    ShiftNoteType["ShiftNote"] = "ShiftNote";
    ShiftNoteType["ShiftPhoto"] = "ShiftPhoto";
    ShiftNoteType["ShiftSignature"] = "ShiftSignature";
})(ShiftNoteType || (exports.ShiftNoteType = ShiftNoteType = {}));
var ShiftRule;
(function (ShiftRule) {
    ShiftRule[ShiftRule["unknown"] = -1] = "unknown";
    ShiftRule[ShiftRule["start_shift"] = 0] = "start_shift";
    ShiftRule[ShiftRule["end_shift"] = 1] = "end_shift";
})(ShiftRule || (exports.ShiftRule = ShiftRule = {}));
var ShiftEndedOrigin;
(function (ShiftEndedOrigin) {
    ShiftEndedOrigin[ShiftEndedOrigin["MANUAL_FROM_APP"] = 2] = "MANUAL_FROM_APP";
    ShiftEndedOrigin[ShiftEndedOrigin["FROM_DASHBOARD"] = 3] = "FROM_DASHBOARD";
    ShiftEndedOrigin[ShiftEndedOrigin["FROM_API"] = 4] = "FROM_API";
    ShiftEndedOrigin[ShiftEndedOrigin["AUTOMATIC_FROM_BRINGG"] = 5] = "AUTOMATIC_FROM_BRINGG";
})(ShiftEndedOrigin || (exports.ShiftEndedOrigin = ShiftEndedOrigin = {}));
//# sourceMappingURL=shift.js.map